<template lang="pug">
  main
    NavBar
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading")
      .container
        .columns
          .column.is-half.is-offset-one-quarter.has-text-centered
            h3.title Reportes Irge
        .columns
          .column.is-12-desktop.is-8-tablet.has-text-centered
            .card
              .card-content
                .columns.is-vcentered
                  .column.is-3-desktop.is-3-tablet.has-text-centered
                    | Seleccione una fecha para los Reportes:
                    .field
                      .control
                        flat-pickr(
                          v-model='fecha'
                          :config="config"
                          class="input"
                        )
                  .column.is-3-desktop.is-3-tablet.has-text-centered
                    a.button.is-link(@click="obtenerLInks")
                      | Generar Reportes
                .columns(v-show="verReportes")
                  .column.is-6
                    a.button.is-danger.is-rounded.is-small(:href="lRep_adenenergy" target="_blank" @click="generarReporte(1)")
                      span.icon
                        i.fas.fa-print
                    span
                      | &nbsp {{ textRep_adenergy }} 
                  .column.is-6
                    a.button.is-danger.is-rounded.is-small(:href="lRep_ducter" target="_blank" @click="generarReporte(0)")
                      span.icon
                        i.fas.fa-print
                    | &nbsp {{ textRep_ducter }}
                .columns(v-show="verReportes")
                  .column.is-6
                    a.button.is-danger.is-rounded.is-small(:href="lRep_financiera" target="_blank" @click="generarReporte(2)")
                      span.icon
                        i.fas.fa-print
                    | &nbsp {{ textRep_financiera }}
                  .column.is-6
                    a.button.is-danger.is-rounded.is-small(:href="lRep_externo" target="_blank" @click="generarReporte(3)")
                      span.icon
                        i.fas.fa-print
                    | &nbsp {{ textRep_externo }}
</template>

<script>
  import NavBar from './layout/NavBar'
  import Loader from '@/components/shared/Loader.vue'
  import flatPickr from 'vue-flatpickr-component'
  import 'flatpickr/dist/flatpickr.css'
  import { Spanish } from "flatpickr/dist/l10n/es.js"
  import { mapState } from 'vuex'
  import moment from 'moment'

  import VisitasServices from '@/services/visitas/visitas'

  export default {
    name: 'Reportes',
    components: { NavBar, Loader, flatPickr },
    data() {
      return {
        isLoading: false,
        config: {
          wrap: true, // set wrap to true only when using 'input-group'
          altFormat: 'Y-m-d',
          altInput: true,
          dateFormat: 'Y-m-d',
          locale: Spanish, // locale for this instance only          
        },
        fecha: moment().format('YYYY-MM-DD'),
        lRep_adenenergy: '',
        lRep_ducter: '',
        lRep_financiera: '',
        lRep_externo: '',
        textRep_adenergy: '',
        textRep_ducter: '',
        textRep_financiera: '',
        textRep_externo: '',
        verReportes: false
      }
    },
    methods: {
      obtenerLInks() {
        this.textRep_externo = `${this.fecha}_Externos_Reporte_Temperatura`
        this.textRep_adenergy = `${this.fecha}_Adenergy_Reporte_Temperatura`
        this.textRep_ducter = `${this.fecha}_Ducter_Reporte_Temperatura`
        this.textRep_financiera = `${this.fecha}_NietoFin_Reporte_Temperatura`
        this.verReportes = true
      },
      generarReporte (comp) {
        this.isLoading = true
        VisitasServices.crearExcel_reporte(this.fecha, comp)
          .then( data => {
            if (data.success) {
              const currentUrl = window.location.hostname
              console.log(currentUrl)
              const link = `https://${currentUrl}/reportesApp/server/excel/corpo/generarReporte.php?nameFile=${data.file}`
              open(link, '_blank')
              setTimeout(() => {
                VisitasServices.borrarArchivo(data.file)
                  .then( dataD => {
                    this.displayToast(dataD.excelBorrado ? 'toasted-primary' : 'bubble', dataD.excelBorrado ? 'Archivo descargado' : 'El archivo no se pudo borrar', dataD.excelBorrado ? 'check' : 'ban', 'OK')
                    this.isLoading = false
                  })
                  .catch(err => {
                    this.displayToast('bubble', `Error2: ${err.message}`, 'ban', 'OK')
                    this.isLoading = false
                  })
              }, 4000)
            } else {
              this.displayToast('bubble', `Error::: ${data.excelBorrado}`, 'ban', 'OK')
              this.isLoading = false
            }
          })
          .catch( e => {
            this.displayToast('bubble', `Error1: ${e.message}`, 'ban', 'OK')
            this.isLoading = false
          })
      },
      displayToast(tema, text, icon, actionText) {
        let toast = this.$toasted.show(text, { 
          theme: tema, 
          position: "bottom-right", 
          duration : 3000,
          iconPack: 'fontawesome',
          icon: icon,
          action : {
            text : actionText,
            onClick : (e, toastObject) => {
              toastObject.goAway(0)
            }
          },
        })
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/visitas_Componentes/ReportesVisitas.vue